import { extract } from '../extractors/holders';

export function buildPromptBlock(project, a) {
  const d = extract(project, a);
  if (!d) return '';
  const lines = ['【Top 10 持有者集中度（Surf）】'];
  if (d.top1Pct != null)            lines.push(`最大持有者占比: ${d.top1Pct.toFixed(2)}%`);
  if (d.top5Pct)                    lines.push(`前5累计占比: ${d.top5Pct.toFixed(2)}%`);
  if (d.top10Concentration != null) lines.push(`前10累计占比: ${d.top10Concentration.toFixed(2)}%`);
  const labeled = d.holders.filter(h => h.label).slice(0, 5);
  if (labeled.length) lines.push(`标注实体 Top 5: ${labeled.map(h => `${h.label}(${h.percent?.toFixed(2)}%)`).join(', ')}`);
  return lines.join('\n');
}
